import XLSX from 'xlsx';
import $ from 'jquery';

/** Set all columns width in a sheet */
export function setColumnSize(sheet, size) {
  // Get the range object from the sheet
  const range = XLSX.utils.decode_range(sheet['!ref']);
  // Set default size for all involved columns
  const colsSize = [];
  for (let i = 0, len = range.e.c; i <= len; i++) {
    colsSize.push({ width: size });
  }
  sheet['!cols'] = colsSize;
}

/**
 * Convert an array of arrays to an HTML table to us in SheetJS (XLSX)
 * @param  {Aray} arrayOfArrays
 * @return {HTMLElement}
 */
export function convertAOAToTable(arrayOfArrays) {
  let table = '<table>';
  arrayOfArrays.forEach((columns) => {
    table += '<tr>';
    columns.forEach((columnContent) => {
      table += `<td>${columnContent}</td>`;
    });
    table += '</tr>';
  });
  table += '<table>';
  return $.parseHTML(table)[0];
}

export default {
  setColumnSize,
  convertAOAToTable,
};
